export { WithoutResultsDirective } from './without-results.directive';
export { WithoutResultsModule } from './without-results.module';
